function createStyleOverride(overrideClass?: string): HTMLStyleElement {
  const tag = document.createElement("style")
  tag.id = overrideClass ?? "gCOverride"
  document.head.appendChild(tag)
  return tag
}

export function getStyleOverride(
  overrideClass?: string
): HTMLStyleElement | HTMLElement {
  return (
    document.getElementById(overrideClass ?? "gCOverride") ??
    createStyleOverride(overrideClass)
  )
}
